/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import useAppointmentTypes from '../../hooks/useAppointmentTypes';
import useSetAppointmentType from '../../hooks/useSetAppointmentType';
import useSetAppointmentTypeName from "../../hooks/useSetAppointmentTypeName";
import useCustomAppointmentTypes from '../../hooks/useCustomAppointmentTypes';
import useSetCustomAppointmentType from '../../hooks/useSetCustomAppointmentType';
import useSetWizardStep from '../../hooks/useSetWizardStep';
import { AppointmentType } from '../../types/AppointmentType';
import { WizardStep } from '../../types/Wizard';
import Loader from '../Loader/Loader';
import useSetPromotions from '../../hooks/useSetPromotions';
import classes from './classes.module.css';
import TrustBox from './TrustBox';


const AppointmentTypeSelection: React.FC = () => {
  const intl = useIntl();
  const [appointmentTypes, isLoading] = useAppointmentTypes();
  const [customAppointmentTypes, isLoadingCustom] = useCustomAppointmentTypes();
  const setStep = useSetWizardStep();
  const setAppointmentType = useSetAppointmentType();
  const setAppointmentTypeName = useSetAppointmentTypeName();
  const setCustomAppointmentType = useSetCustomAppointmentType();
  const setPromotions = useSetPromotions();
  const handleClick = React.useCallback(
    (appointmentType: AppointmentType, promotions: boolean) => () => {
      setAppointmentType(appointmentType);
      setAppointmentTypeName(intl.formatMessage({ id: 'appointmentTypeSelection.' + appointmentType.id + '.name' }));
      setStep((prev) => (prev + 1) as WizardStep);
      setPromotions(promotions);
    },
    [setAppointmentType, setCustomAppointmentType, setPromotions, setStep],
  );

  if (isLoading || isLoadingCustom) {
    return <Loader />;
  }

  return (
    <div className={classes.outer}>
      <div className={classes.container}>
        <h2>{intl.formatMessage({ id: 'appointmentTypeSelection.title' })}</h2>
        <div className={classes.wrapper}>
          {appointmentTypes &&
            appointmentTypes
              .filter((f) => f.isEnabled)
              .map((t) => (
                <div key={t.id} className={classes.box}>
                  <div>
                    <h3>{intl.formatMessage({ id: 'appointmentTypeSelection.' + t.id + '.name' })}</h3>
                    {intl.formatMessage({ id: 'appointmentTypeSelection.' + t.id + '.description' }) != '-'
                      ? intl.formatMessage({ id: 'appointmentTypeSelection.' + t.id + '.description' })
                      : null}
                  </div>
                  <div>
                    <button
                      className={classes.buttonNext}
                      tabIndex={0}
                      aria-pressed='false'
                      onClick={handleClick(t, false)}
                    >
                      {intl.formatMessage({ id: 'appointmentTypeSelection.selectButton' })}
                    </button>
                  </div>
                </div>
              ))}
          {(window as any).displayPromotions &&
            appointmentTypes &&
            appointmentTypes
              .filter((f) => f.isEnabled && f.duration === 30)
              .map((t) => (
                <div key={t.id} className={clsx(classes.box, 'promotions')}>
                  <div>
                    <h3>{intl.formatMessage({ id: 'promotions.title' })}</h3>
                  </div>
                  <div>
                    <button
                      className={classes.buttonNext}
                      tabIndex={0}
                      aria-pressed='false'
                      onClick={handleClick(t, true)}
                    >
                      {intl.formatMessage({ id: 'appointmentTypeSelection.selectButton' })}
                    </button>
                  </div>
                </div>
              ))}

          {customAppointmentTypes &&
            customAppointmentTypes.map((t) => (
              <div key={t.guid} className={classes.box}>
                <div>
                  <h3>{t.title}</h3>
                  {t.description}
                </div>
                <div>
                  <a href={t.link} className={classes.buttonNext}>
                    {intl.formatMessage({ id: 'appointmentTypeSelection.selectButton' })}
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
      <TrustBox />
    </div>
  );
};
AppointmentTypeSelection.displayName = 'AppointmentTypeSelection';

export default AppointmentTypeSelection;
